﻿import { RefObject, useCallback, useEffect } from 'react';
import { useSliderContext } from '../SliderContext';

type UseKeyboardProps = {
  root: RefObject<HTMLElement>
  index: RefObject<number>
  updateIndex: (newIndex: number) => void
  slideAmount: RefObject<number>,
  setEasingFunction: (type: 'click') => void
}

const useKeyboard = (
  {
    setEasingFunction,
    updateIndex,
  }: UseKeyboardProps) => {
  const { root, index, slideAmount } = useSliderContext();

  const handleArrowKeys = useCallback((e: KeyboardEvent) => {
    let newIndex = index.current;

    if (e.key === 'ArrowRight') {
      newIndex = index.current + slideAmount.current;
    }

    if (e.key === 'ArrowLeft') {
      newIndex = index.current + (slideAmount.current * -1);
    }
    setEasingFunction('click');
    updateIndex(newIndex);

  }, [index, setEasingFunction, updateIndex, slideAmount]);

  useEffect(() => {
    if (!root.current) return;
    const rootRef = root.current;

    rootRef.addEventListener('keydown', handleArrowKeys);

    return () => {
      rootRef.removeEventListener('keydown', handleArrowKeys);
    };
  }, [handleArrowKeys, root]);
};

export default useKeyboard;